// 9fbef606107a605d69c0edbcd8029e5d
import { isCanada } from '@tcp/core/src/utils';

const country = isCanada() ? 'ca' : 'us';

const CHECKOUT_STAGES = {
  PICKUP: 'pickup',
  SHIPPING: 'shipping',
  BILLING: 'billing',
  REVIEW: 'review',
  CONFIRMATION: 'confirmation',
  MINIBAG: 'miniBag',
  INTERNATIONAL_CHECKOUT: 'international-checkout',
};

export const ADDED_TO_BAG_PAGE = 'isAddedToBagPage';

export const CHECKOUT_PAGE = 'checkout';

export const PRODUCT_DETAIL_PAGE = 'isProductDetailView';

export const CHECKOUT_SECTIONS = {
  [CHECKOUT_STAGES.PICKUP]: {
    id: CHECKOUT_STAGES.PICKUP,
    page: CHECKOUT_PAGE,
    displayName: 'Pickup',
    pathPart: 'pickup',
    pathPattern: `/${country}/checkout/pickup`,
  },
  [CHECKOUT_STAGES.SHIPPING]: {
    id: CHECKOUT_STAGES.SHIPPING,
    page: CHECKOUT_PAGE,
    displayName: 'Shipping',
    pathPart: 'shipping',
    pathPattern: `/${country}/checkout/shipping`,
  },
  [CHECKOUT_STAGES.BILLING]: {
    id: CHECKOUT_STAGES.BILLING,
    page: CHECKOUT_PAGE,
    displayName: 'Billing',
    pathPart: 'billing',
    pathPattern: `/${country}/checkout/billing`,
  },
  [CHECKOUT_STAGES.REVIEW]: {
    id: CHECKOUT_STAGES.REVIEW,
    page: CHECKOUT_PAGE,
    displayName: 'Review',
    pathPart: 'review',
    pathPattern: `/${country}/checkout/review`,
  },
  [CHECKOUT_STAGES.CONFIRMATION]: {
    id: CHECKOUT_STAGES.CONFIRMATION,
    page: CHECKOUT_PAGE,
    displayName: '',
    pathPart: 'confirmation',
    pathPattern: `/${country}/checkout/confirmation`,
  },
};

export const SYTE_CONFIGURATION = {
  tcp: {
    accountId: '9561',
    accountSignature: '62ccff454d0b635d7e9944bf',
    languageCode: 'en_US',
  },
  gym: {
    accountId: '9565',
    accountSignature: '62d68c8a4d0b635d7e9a44d7',
    languageCode: 'en_US',
  },
  snj: {
    accountId: '9566',
    accountSignature: '62d68d194d0b635d7e9a4524',
    languageCode: 'en_US',
  },
};

export default CHECKOUT_STAGES;
